import { Link } from "@caspeco/casper-ui-library.components.link";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";

export function PhoneNumberLink() {
    const externalBookingSettings = useExternalBookingSettings().data;
    const href = `tel:${externalBookingSettings.phoneNumber}`;
    return <Link href={href}>{externalBookingSettings.phoneNumber}</Link>;
}
